import React from 'react';
import {useForm, Controller} from 'react-hook-form';
import {Button, Dialog, DialogTitle, Divider, Grid, MenuItem, Select} from '@mui/material';
import IyoFormSection from '../../common/IyoFormSection';

const CreateDeviceDialog = (props) => {
  const {control, handleSubmit} = useForm();

  const handleClose = () => {
    props.setOpen(false);
  };

  // The list arrives from a query, so it is null until that query resolves - and stays null
  // if it fails. Rendering an empty menu beats taking the dialog down with it.
  const owners = Array.isArray(props.owners) ? props.owners : [];

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth={true}
    >
      {/* Was rendered with its quotes showing: 'Create Device for Owner'. */}
      <DialogTitle>
        Create Device
      </DialogTitle>
      <form onSubmit={handleSubmit(props.onSubmit)}>
        <div style={{margin: '2%'}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <IyoFormSection
                title='Owner'
                description='Who the device belongs to. It cannot be moved afterwards.'
              >
                <Controller
                  name='owner_id'
                  control={control}
                  render={({field: {onChange, value}, fieldState: {error}}) => (
                    <Select
                      labelId='owner-label'
                      id='owner-id'
                      value={value}
                      label='Owner'
                      defaultValue=''
                      displayEmpty
                      fullWidth
                      error={Boolean(error)}
                      renderValue={(selected) => {
                        if (selected === '') {
                          return 'Please select owner to create device for...'
                        }
                        return owners.find(x => x.id === selected)?.name ?? '';
                      }}
                      onChange={onChange}
                    >
                      {
                        owners.map((owner) =>
                          <MenuItem key={owner.id} value={owner.id}>{owner.name}</MenuItem>
                        )
                      }
                    </Select>
                  )}
                  rules={{required: true}}
                />
              </IyoFormSection>
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{mb: 2}}/>
              <Button
                color='primary'
                onClick={handleClose}
                size='large'
                type='button'
                variant='outlined'
                sx={{mr: 1}}
              >
                Cancel
              </Button>
              <Button
                color='primary'
                size='large'
                type='submit'
                variant='contained'
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </div>
      </form>
    </Dialog>
  );
};

export default CreateDeviceDialog;
